import React, { useState } from 'react'
import httpClient from '../../httpClient'
import { Box, Button, Grid, Paper, TextField } from "@mui/material";

    const RegisterPage = (props:any) => {
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [name, setName] = useState<string>("")
    const [phone, setPhone] = useState<string>("")
    const [birth, setBirth] = useState<string>("")
    const [gender, setGender] = useState<string>("")

    const open = props.switchPage;
    var control = 'none';
    if(open)
        control = 'block'

    const RegisterUser = async () => {
        console.log(email, password);

        try {
            const resp = await httpClient.post("//121.135.229.125:4546/register", {
                email,
                password,
                name,
                phone,
                birth,
                gender
            });

            window.location.href = '/';
        } catch (error: any) {
            if (error.response.status === 401){
                alert("Invalid credentails");
            }   
        }

    }

  return (
    <React.Fragment>
    <Box sx={{ width: "100%", textAlign: "center", display: control }}>
      <Grid container>
        <Paper elevation={3} sx={{ margin: "auto", padding: "46px" }}>
          <div>
            <Box sx={{display: "flex", justifyContent: "center"}}>
              <Box sx={{display: "flex"}}>
                <img style={{width:"34px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/insight_logo2.png'} />
              </Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:600, fontSize: "large", alignSelf: "center"}}>INSIGHT HUB</Box>  
            </Box>
            <h1>Create an Account</h1>
            {/* <form> */}
              <Box sx={{padding:3, backgroundColor:"#e7eef3", borderRadius: "2%"}}>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1}}>Email</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="email" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setEmail(e.target.value)} value={email} />
                </Box>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1, marginTop:2}}>Password</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="password" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setPassword(e.target.value)} value={password} />
                </Box>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1, marginTop:2}}>이름</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="text" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setName(e.target.value)} value={name} />
                </Box>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1, marginTop:2}}>생년월일</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="text" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setBirth(e.target.value)} value={birth} />
                </Box>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1, marginTop:2}}>성별</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="text" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setGender(e.target.value)} value={gender} />
                </Box>
                <Box>
                  <Box sx={{textAlign:"left", marginLeft:1, fontWeight:600, marginBottom:1, marginTop:2}}>연락처</Box>
                  <TextField sx={{backgroundColor:"#fff"}} type="text" id="outlined-basic" variant="outlined" fullWidth size="small" onChange={(e) => setPhone(e.target.value)} value={phone} />
                </Box>
                <Box>
                  <Button sx={{width:"100%", marginTop:3, fontSize:"16px", fontWeight:600, color:"#fff", backgroundColor:"#00b0ff",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={() => RegisterUser()}>Register</Button>
                </Box>
                <Box>
                  <Button sx={{width:"100%", marginTop:3, fontSize:"16px", fontWeight:600, color:"#fff", backgroundColor:"#00b0ff",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={() => props.setSwitchPage(false)}>Back</Button>
                </Box>
              </Box>
              {/* <button type="button" onClick={() => RegisterUser()}>Submit</button> */}
            {/* </form> */}
          </div>
        </Paper>
      </Grid>
    </Box>
    {/* <div>
        <h1>Create an Account</h1>
        <form>
            <div>
                <label>Email: </label>
                <input type="text" value={email} onChange={(e)=> setEmail(e.target.value)} id="" />
            </div>
            <div>
                <label>Password: </label>
                <input type="password" value={password} onChange={(e)=> setPassword(e.target.value)} id="" />
            </div>
            <button type="button" onClick={() => RegisterUser()}>Submit</button>
        </form>
    </div> */}
    </React.Fragment>
  )
}

export default RegisterPage